module.exports = __webpack_public_path__ + "static/media/coop.0d3f52ba.svg";